import React from "react";
import Layout from "./Layout";
import QRLinks from "./QRLinks";
import PhoneQR from "./PhoneQR";
import { Helmet } from "react-helmet";

function PhoneQrCodes() {
  return (
    <Layout>
      <Helmet>
        <title>Phone QR Code Generator - Instant QR Codes</title>
        <met
          name="description"
          content="Generate a qr code that changes your phone number to a scannable qr code instantly, for free."
        />
        <link
          rel="canonical"
          href="https://instantqrcodes.com/phone-qr-code/"
        />
      </Helmet>
      <QRLinks />
      <PhoneQR />
    </Layout>
  );
}

export default PhoneQrCodes;
